import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13f05d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changeSkin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_sub" }, "请先前往云管系统-在线预订中生成次卡", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载二维码")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_9 = {
  slot: "footer",
  class: "dialog-footer"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确 定")

import { ref, getCurrentInstance, onMounted } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { ElMessage, ElMessageBox } from 'element-plus'
  // import type { Action } from 'element-plus'
  // import { Warning } from '@element-plus/icons-vue'
  import { getOnceCardList, getCsCardList, createOnceCard, getOnceCardDetail,editOnceCard, delOnceCard } from '@/axios/smartMarket';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'numCard',
  setup(__props) {

  let { proxy } = getCurrentInstance() as any;
  let cardDialog = ref(false);
  let cards = ref();
  let tableData = ref([])
  let cardList = ref<any>([])
  let form = ref({
    id: 0,
    activity_name: '',
    status: 0,
    company_id: 0,
  })

  onMounted(() => {

    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getCsCardList({
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
      parent_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      page: 1,
      page_size: 50
    }).then((data:any) => {
      cardList.value = data;
    }).catch((err:any) => {
      console.log(err)
    })
    getsOnceCardLists();
  })

  //获取活动列表
  function getsOnceCardLists(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '');
    getOnceCardList({
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any)=>{
      tableData.value = data[0]?data:[];
    }).catch((err:any)=>{
      
    })
  }

  //展示弹窗
  function showCard(id?:number) {
    cardDialog.value = true;
    if(id){
      getOnceCardDetail({
        id: id
      }).then((data:any) => {
        form.value = data;
        cards.value = Number(data.card_id)
      }).catch((err:any) => {})
    }
  }
  //下载图片
  function downsLoad(companyId:number){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    let partenId = aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id;
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var url = URL.createObjectURL(this.response);
      var img = new Image();
      img.onload = function () {
          // 此时你就可以使用canvas对img为所欲为了
          var a = document.createElement("a");
          a.download = '活动';
          a.href =url;
          a.click();
          // 图片用完后记得释放内存
          URL.revokeObjectURL(url);
      };
      img.src = url;
    };
    xhr.open('GET', `${proxy.$downUrl}/admin/qrcode/createCardQrcode?parent_id=${partenId}&company_id=${companyId}`, true);
    xhr.responseType = 'blob';
    xhr.send();
    
  }
  //删除
  function delBar(id:number){
    ElMessageBox.alert('是否确认删除', '提示', {
      confirmButtonText: 'OK',
      callback: (action: any) => {
        console.log(action)
        if(action == 'confirm'){
          delOnceCard({
            id: id
          }).then((data:any) => {
            ElMessage('删除成功')
            getsOnceCardLists();
            closeDia();
          }).catch((err:any) => {})
          
        }
      },
    })
  }
  //关闭弹窗
  function closeDia(){
    cardDialog.value = false;
    form.value = {
      id: 0,
      activity_name: '',
      status: 0,
      company_id: 0
    }
    cards.value = '';
  }
  //确认
  function formClicks(){
    if(!form.value.activity_name){
      ElMessage('请输入活动名称');
      return false;
    }
    if(!cards.value){
      ElMessage('请活动次卡');
      return false;
    }
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '');
    let title = '';
    cardList.value.some((item:any) => {
      if(cards.value == item.numbercardid){
        title = item.title;
        return true;
      }
    })
    //新增
    if(!form.value.id){
      createOnceCard({
        company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
        card_id: cards.value,
        activity_name: form.value.activity_name,
        card_name: title,
        status: form.value.status
      }).then((data:any) => {
        ElMessage('新增活动成功');
        getsOnceCardLists();
        closeDia();
      }).catch((err:any) => {})
    }
    else{
      editOnceCard({
        id: form.value.id,
        company_id: form.value.company_id,
        card_id: cards.value,
        activity_name: form.value.activity_name,
        card_name: title,
        status: form.value.status
      }).then((data:any) => {
        ElMessage('编辑活动成功');
        getsOnceCardLists();
        closeDia();
      }).catch((err:any) => {})
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(pageTitle, { title: "次卡营销" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, {
            size: 18,
            class: "ics"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Warning)
            ]),
            _: 1
          }),
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "add_btn",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showCard()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "排序",
            width: "80px"
          }),
          _createVNode(_component_el_table_column, {
            prop: "activity_name",
            label: "活动名字",
            width: "150px"
          }),
          _createVNode(_component_el_table_column, {
            prop: "card_name",
            label: "次卡名字",
            width: "150px"
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "150px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.status==0?'停用':'启用'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (downsLoad(scope.row.company_id))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (showCard(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (delBar(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _unref(form).id?'编辑营销位':'新增营销位',
      modelValue: _unref(cardDialog),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(cardDialog) ? (cardDialog).value = $event : cardDialog = $event)),
      onClose: closeDia,
      width: "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "活动名字" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).activity_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).activity_name) = $event)),
                  placeholder: "输入活动名字，不对外展示"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "选择次卡" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(cards),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(cards) ? (cards).value = $event : cards = $event)),
                  placeholder: "请选择次卡"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.numbercardid,
                        label: item.title,
                        value: item.numbercardid
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, { onClick: closeDia }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: formClicks
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})